import styled from '@emotion/styled';

export const ImageContainer = styled('div')<{
  align?: 'left' | 'center' | 'right' | 'fill';
  width?: number;
}>((p) => ({
  display: 'flex',
  justifyContent:
    p.align === 'left'
      ? 'flex-start'
      : p.align === 'center'
      ? 'center'
      : p.align === 'right'
      ? 'flex-end'
      : 'flex-start',
  alignItems: 'center',
  maxWidth: '100%',
  width: '100%',
  '> img, > div' : {
    maxWidth: `${p.width}%`,
    width: `${p.width}%`
  }
}));
